import "slick-carousel"

export default {
	init() {
		var recept_slider = $(".recept-galerija")

		if (recept_slider.length > 0) {
			recept_slider.slick({
				dots: false,
				arrows: false,
				autoplay: true,
				autoplaySpeed: 4500,
				speed: 200,
			})

			var recept_slider_nav = $(".recept-galerija-nav")

			recept_slider_nav.slick({
				slidesToShow: 6,
				slidesToScroll: 1,
				asNavFor: '.recept-galerija',
				dots: false,
				centerMode: false,
				focusOnSelect: true,
			})
		}
		
	}
}